import React, { PropTypes } from 'react';

import { apiErrorPropType, eventFullPropType } from '../../proptypes';

import Container from '../Container';
import EventReviewPageMeta from './components/EventReviewPageMeta';
import EventReview from '../../containers/EventReview';
import LoadingEllipsis from '../LoadingEllipsis';

import { container } from './styles.module.css';

/**
 * Event review page presentational component.
 * Combines event review component with loading and/or error components.
 **/
const EventReviewPage = ({ fetching, error, event }) => {
  if (event) {
    return (
      <div>
        <EventReviewPageMeta {...event} />
        <EventReview {...event} />
      </div>
    );
  }
  if (fetching) {
    return (
      <Container className={container}>
        <LoadingEllipsis htmlTag="h1" />
      </Container>
    );
  }
  return (
    <Container className={container}>
      <h1>{error && error.status === 404 ? 'Event not found' : 'Something went wrong'}</h1>
    </Container>
  );
};

EventReviewPage.propTypes = {
  /**
   * Boolean describing current loading state.
   */
  fetching: PropTypes.bool,
  /**
   * Object representing current error state.
   */
  error: apiErrorPropType,
  /**
   * Event data object.
   */
  event: eventFullPropType,
};

EventReviewPage.defaultProps = {
  fetching: false,
  error: null,
  event: null,
};

export default EventReviewPage;



// WEBPACK FOOTER //
// ./app/src/components/EventReviewPage/index.jsx